import { Button } from '@/components/ui/Button';
import { getRelayService } from '@/services/session';
import { relayLamp, useNetworkStore } from '@/store/network';

const TONE_CLASS: Record<'ok' | 'warn' | 'err', string> = {
  ok: 'bg-ok',
  warn: 'bg-warn',
  err: 'bg-err',
};

/**
 * `RelayCard` —— 中继状态卡（地址 / 状态灯 / 延迟）+ 「切换中继」按钮。
 *
 * 数据源唯一：`useNetworkStore(s => s.relay)`（`peerId/addr/status/latencyMs`）。
 * 「切换中继」经 `getRelayService()?.switchRelay()`（`services/session.ts` 导出的句柄）落地，
 * 使 `E_RELAY_UNAVAILABLE` 的 `switchRelay` 动作在 UI 侧**可达**。挂载见 `features/settings/SettingsPage.tsx`。
 */
export function RelayCard(): JSX.Element {
  const relay = useNetworkStore((s) => s.relay);
  const { label, tone } = relayLamp(relay.status);

  return (
    <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
      <p className="flex min-w-0 items-center gap-2 text-[11px] text-dim">
        <span className={`inline-block h-2 w-2 shrink-0 rounded-full ${TONE_CLASS[tone]}`} title={label} />
        <span className="truncate">{relay.addr ? `${relay.addr.slice(0, 45)}…` : '未连接'}</span>
        <span>（{label}）</span>
        {typeof relay.latencyMs === 'number' ? <span>· {relay.latencyMs}ms</span> : null}
      </p>
      <Button variant="ghost" size="sm" onClick={() => void getRelayService()?.switchRelay()}>
        切换中继
      </Button>
    </div>
  );
}

export default RelayCard;
